<template>
  <div>
    <el-button
      class="header_btn"
      size="medium"
      type="text"
      @click="gongz"
      >我的教材</el-button
    >
    <!-- 查看教材 -->
    <el-dialog
      title="教材列表"
      class="listbook"
      :visible.sync="ccdialogVisible"
      style="padding: 0px 20px"
      width="30%"
      :modal="false"
    >
      <el-col class="booklist" v-for="(item, index) in bookList" :key="index">
        <el-col :span="20">{{ item.bookName }}</el-col>
        <el-col :span="4">
          <i
            class="el-icon-delete huang"
            @click="deleteBook(item.tbookId, item.bookName)"
          ></i
        ></el-col>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="addBooks"
          >添加教材</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加教材 -->
    <el-dialog
      title="添加教材"
      class="listbook"
      :visible.sync="adddialogVisible"
      style="padding: 0px 20px"
      width="30%"
      :modal="false"
    >
      <el-col>
        <el-col :span="4">学科：</el-col>
        <el-col :span="20">
          <el-col
            :span="8"
            v-for="(item, index) in bookSubjectList"
            :key="index"
            ><div
              :class="activeClass == index ? 'active' : ''"
              style="cursor: pointer"
              @click="disciplineId(item.id, index)"
            >
              {{ item.name }}
            </div></el-col
          >
        </el-col>
      </el-col>

      <el-col v-show="disciplineIds">
        <el-col :span="4">版本：</el-col>
        <el-col :span="20">
          <el-col :span="8" v-for="(item, index) in versionList" :key="index"
            ><div
              :class="activeClas == index ? 'active' : ''"
              style="cursor: pointer"
              @click="versionId(item.verId, index)"
            >
              {{ item.verName }}
            </div></el-col
          >
        </el-col>
      </el-col>

      <el-col v-show="versionIds">
        <el-col :span="4">年级：</el-col>
        <el-col :span="20">
          <el-col :span="8" v-for="(item, index) in volumeList" :key="index"
            ><div
              :class="activeClasss == index ? 'active' : ''"
              style="cursor: pointer"
              @click="gradeId(item.gradeId, item.volumeId, index)"
            >
              {{ item.volumeName }}
            </div></el-col
          >
        </el-col>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          @click="
            adddialogVisible = false
            ccdialogVisible = true
          "
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="addBook"
          :disabled="disableds()"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getBookList,
  deleteBook,
  getBookSubjectList,
  getVersionList,
  getVolumeList,
  getChaptertreeVo,
  addBook,
} from '@/api/home'
export default {
  name: "addbook",
  data() {
    return {
      ccdialogVisible: false, //查看教材
      adddialogVisible: false, //添加教材
      bookList: [], //自己教材列表
      bookSubjectList: [],
      versionList: [],
      volumeList: [],
      ChaptertreeVoList: [],
      disciplineIds: 0,
      versionIds: 0,
      gradeIds: 0,
      volumeIds: 0,
      activeClass: -1,
      activeClas: -1,
      activeClasss: -1,
      Code: '',
    }
  },
  created() {},
  methods: {
    gongz() {
      this.getBookList()
      this.ccdialogVisible = true
    },
    // 查看教材
    async getBookList() {
      const { data: res } = await getBookList()
      if (res.code == 90007) {
        this.$message.error('登录过期，请重新登录！！！')
        localStorage.clear()
        this.$router.push('/')
      }
      this.bookList = res.data
    },
    disableds() {
      if (this.Code === '0') {
        return false
      } else {
        return true
      }
    },

    // 删除教材
    async deleteBook(id, bookname) {
      const confirResult = await this.$confirm(
        '是否删除' + bookname + '教材?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      if (confirResult !== 'confirm') {
        return this.$message.info('已取消！！')
      }
      // 删除接口
      try {
        const res = await deleteBook(id)
        this.getBookList()
      } catch (err) {
        console.log(err)
      }
    },

    // 添加教材
    addBooks() {
      this.getBookSubjectList()
      this.adddialogVisible = true
      this.ccdialogVisible = false
    },

    // 获取全部学科列表
    async getBookSubjectList() {
      const { data: res } = await getBookSubjectList()
      console.log('book', res)
      if (res.code !== '0') {
      }
      this.bookSubjectList = res.data
    },

    disciplineId(id, k) {
      this.disciplineIds = id
      this.getVersionList()
      this.activeClass = k
    },

    // 获取版本分类列表
    async getVersionList() {
      const { data: res } = await getVersionList({
        subjectId: this.disciplineIds,
      })
      this.versionList = res.data
      console.log('this.versionList', this.versionList)
    },
    // 选择版本
    versionId(id, k) {
      this.versionIds = id
      this.activeClas = k
      this.ChaptertreeVoList = []
      this.activeClasss = -1
      this.getVolumeList()
    },

    // 获取年级册别列表
    async getVolumeList() {
      const { data: res } = await getVolumeList({
        subjectId: this.disciplineIds,
        versionId: this.versionIds,
      })
      this.volumeList = res.data
    },
    gradeId(id, ids, k) {
      this.gradeIds = id
      this.volumeIds = ids
      this.activeClasss = k
      this.getChaptertreeVo()
    },

    // 获取教材章节树
    async getChaptertreeVo() {
      const { data: res } = await getChaptertreeVo({
        gradeId: this.gradeIds,
        subjectId: this.disciplineIds,
        verId: this.versionIds,
        volumeId: this.volumeIds,
      })
      this.ChaptertreeVoList = res.data
      this.Code = res.code
      if (this.Code !== '0') {
        this.$message.error('并没有这个教材,请联系管理员！！')
      }
      this.disableds()
    },

    // 点击添加书籍
    async addBook() {
      if (this.Code !== '0') {
        this.$message.error('请重新选择！！！')
      } else {
        const { data: res } = await addBook({
          bookId: this.ChaptertreeVoList.bookId,
          bookName: this.ChaptertreeVoList.bookName,
          gradeId: this.ChaptertreeVoList.gradeId,
          subjectId: this.ChaptertreeVoList.subjectId,
          verId: this.ChaptertreeVoList.verId,
          volumeId: this.ChaptertreeVoList.volumeId,
        })

        this.$message({
          message: '添加成功',
          type: 'success',
        })
        this.getBookList()
        this.adddialogVisible = false
        this.ccdialogVisible = true
      }
    },
  },
}
</script>
<style scoped>
.header_btn {
  float: left;
  /* margin-top: 4px; */
  /* display: inline-block; */
  font-size: 14px;
}
.huang {
  color: #e2754a;
  cursor: pointer;
  float: right;
}
.el-col-24 {
  margin-bottom: 10px;
}
.el-col-8 {
  margin-bottom: 5px;
}
.active {
  color: #306ef3;
}
</style>


// WEBPACK FOOTER //
// src/views/bench/components/addbook.vue